import { render, staticRenderFns } from "./noAppNoDoc.vue?vue&type=template&id=76ed3de4&"
import script from "./noAppNoDoc.vue?vue&type=script&lang=js&"
export * from "./noAppNoDoc.vue?vue&type=script&lang=js&"
import style0 from "./noAppNoDoc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ed3de4')) {
      api.createRecord('76ed3de4', component.options)
    } else {
      api.reload('76ed3de4', component.options)
    }
    module.hot.accept("./noAppNoDoc.vue?vue&type=template&id=76ed3de4&", function () {
      api.rerender('76ed3de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/subcomponents/noAppNoDoc.vue"
export default component.exports